import React from "react";

import Box from "../Box";

const Video = props => {
  return (
    <section className="hp__block hp__block--video container-fluid">
      <div className="row">
        <section className="hp__block hp__block--one-image special-box-one-image">
          <div className="row">
            <Box
              {...props}
              id="b1"
              type="pile"
              settings={props.settings.b1}
              classes="hp__box--main col-xs-12 col-sm-9"
              thumbnailHeight="825"
            />
          </div>
        </section>

        <div className="hp__box--column hp__box--column--video col-xs-12 col-sm-3">
          <section className="hp__block hp__block--three container">
            <div className="row hp__block__row hp__block__row--first">
              <Box
                {...props}
                id="b2"
                type="news"
                settings={props.settings.b2}
                classes="col-xs-6 col-md-4"
              />
              <Box
                {...props}
                id="b3"
                type="news"
                settings={props.settings.b3}
                classes="col-xs-6 col-md-4 hp__box__xs__right"
              />
              <Box
                {...props}
                id="b4"
                type="news"
                settings={props.settings.b4}
                classes="col-xs-12 col-md-4"
              />
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default Video;
